export default function EquipmentFiltersDirective() {
  return {
    restrict: 'E',
    template: require('./equipment-filters.component.html'),
    scope: {
      filters: '=',
      assetPicker: '='
    },
    controller: EquipmentFiltersController
  };

  function EquipmentFiltersController($rootScope, $scope, securityGroupsService, gettext) {
    'ngInject';
    let currentUser = $rootScope.currentUser;
    $scope.securityGroups = [];
    $scope.showGroups = false;

    function getSecurityGroups() {
      if (currentUser.account.securityMode === 'Open') {
        $scope.securityGroups = [];
        return;
      }
      if (currentUser.securityMode !== 'Open') {
        $scope.securityGroups = currentUser.groups.data;
        if ($scope.securityGroups.length > 1) {
          $scope.showGroups = true;
        }
      } else {
        securityGroupsService.getAllSecurityGroups().then(
          function(response) {
            $scope.securityGroups = response.data.data;
            if ($scope.securityGroups.length > 0) {
              $scope.showGroups = true;
            }
          },
          function(error) {
            $scope.securityGroups = [];
          }
        );
      }
    }

    getSecurityGroups();

    $scope.maintenanceOptions = [];
    $scope.maintenanceOptions.push({
      name: gettext('Due'),
      id: 'due',
      icon: 'fa fa-wrench color-high-priority'
    });

    $scope.maintenanceOptions.push({
      name: gettext('Upcoming'),
      id: 'upcoming',
      icon: 'fa fa-wrench color-low-priority'
    });

    $scope.alertPriorities = [];
    $scope.alertPriorities.push({
      name: gettext('Low'),
      id: 'low',
      icon: 'fa fa-exclamation-circle'
    });

    $scope.alertPriorities.push({
      name: gettext('Medium'),
      id: 'medium',
      icon: 'fa fa-exclamation-circle color-medium-priority'
    });

    $scope.alertPriorities.push({
      name: gettext('High'),
      id: 'high',
      icon: 'fa fa-exclamation-circle color-high-priority'
    });

    // scope function to clear filters
    $scope.clearFilters = function() {
      if ($scope.filters) {
        $scope.filters.maintenance = {};
        $scope.filters.priorities = {};
        if ($scope.filters.securityGroups) {
          $scope.filters.securityGroups = {};
        }
      }
    };

    // retrun true if filter set up show / hide  filters
    $scope.showclearFilters = function() {
      if ($scope.filters) {
        if ($scope.filters.maintenance && $scope.filters.maintenance.length > 0) return true;
        if ($scope.filters.priorities && $scope.filters.priorities.length > 0) return true;
        if ($scope.filters.securityGroups && $scope.filters.securityGroups.length > 0) return true;
      }
      return false;
    };
  }
}
